module.exports = __webpack_public_path__ + "static/media/app-store-google.4d63c31a.svg";